import { styled } from '@mui/material';

const StyledInfoBlockList = styled('div')(() => ({
	display: 'grid',
	marginTop: '24px',
	padding: '8px',
	gap: '8px',
	gridTemplateColumns: '1fr',
}));

export default StyledInfoBlockList;
